'use client'

import { Provider } from 'jotai'
// import { DevTools } from 'jotai-devtools'
// import 'jotai-devtools/styles.css'

export const JotaiProvider = ({ children }) => {
  return (
    <Provider>
      {children}
      {/* <DevTools /> */}
    </Provider>
  )
}